export let DataStateKey;

(function (DataStateKey) {
  DataStateKey["value"] = "value";
  DataStateKey["prefilled"] = "prefilled";
  DataStateKey["completed"] = "completed";
  DataStateKey["skipped"] = "skipped";
  DataStateKey["validation"] = "validation";
  DataStateKey["errorMessage"] = "errorMessage";
})(DataStateKey || (DataStateKey = {}));